import type { ReusableComponentType } from "@repo/shared/types";

/**
 * Query key for the unified reuse-availability endpoint. Lives in its own leaf module so the save
 * hooks (which invalidate it) and the apply hook (which also imports the per-component value-key
 * factories) can both depend on it without a circular import.
 */
export const reuseKeys = {
  /** QL-505 — `subjectId` addresses one party when several answer (a group member, or a representative when 2+ are registered). */
  availability: (
    id: string | null,
    componentType: ReusableComponentType,
    subjectId?: string | null,
  ) => ["flowInstances", id, "reuse-availability", componentType, subjectId ?? null] as const,
};
